import { FormControl, FormLabel } from '@chakra-ui/react';
import { Props, Select } from 'chakra-react-select';
import { useController, UseControllerProps } from 'react-hook-form';
import { FormValues } from './FormCompany';

type ControlledSelectProps = UseControllerProps<FormValues> &
  Props & {
    label: string;
  };

export default function ControlledSelect({
  control,
  name,
  label,
  rules,
  isRequired,
  ...props
}: ControlledSelectProps) {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error }
  } = useController<FormValues>({
    name,
    control,
    rules,
  });

  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      <FormLabel>{label}</FormLabel>
      <Select
        name={name}
        ref={ref}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        {...props}
      />
    </FormControl>
  );
}
